import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  Typography,
  TextField,
  makeStyles,
} from '@material-ui/core';
import * as yup from 'yup';
import RyffineDialogTitle from '../common/RyffineDialogTitle';
import { isObjectEmpty } from '../../core/services/commonService';
import { addProject } from '../../redux/actions/projectsActions';

const useStyles = makeStyles(() => ({
  field: {
    '& .MuiInputBase-root': {
      '& .MuiInputBase-input': {
        padding: '8px 0px 8px 16px',
      },
      borderRadius: '4px',
      background: '#FFFFFF',
      padding: 0,
    },
  },
}));

const validationSchema = yup.object({
  projectName: yup
    .string()
    .required('Project name is required')
    .min(2, 'Project name must be at least 2 characters'),
});

const initValues = () => ({
  projectName: '',
});

function AddProjectDialog({ open, onClose }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: initValues(),
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => {
      dispatch(addProject(values.projectName));
      onClose();
      formik.resetForm();
    },
  });

  const clickAddButton = () => {
    formik.validateForm().then(errors => {
      if (isObjectEmpty(errors)) {
        formik.handleSubmit();
      } else {
        formik.setErrors(errors);
      }
    });
  };

  return (
    <Dialog maxWidth="sm" fullWidth onClose={onClose} open={open}>
      <RyffineDialogTitle onClose={onClose}>Add New Project</RyffineDialogTitle>

      <DialogContent style={{ background: '#F8F8F8' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{
              fontSize: '14px',
              fontWeight: 500,
              marginTop: '16px',
              marginBottom: '5px',
            }}
            >
              Project Name
            </Typography>
            <FormControl fullWidth error={Boolean(formik.errors.projectName)}>
              <TextField
                placeholder="Project Name"
                name="projectName"
                id="projectName"
                variant="outlined"
                value={formik.values.projectName}
                onChange={formik.handleChange}
                className={classes.field}
                error={Boolean(formik.errors.projectName)}
              />
              {formik.errors.projectName && (
                <FormHelperText>{formik.errors.projectName}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ padding: '10px 24px 24px 24px', background: '#F8F8F8' }}>
        <Grid container>
          <Grid item xs={12}>
            <Button onClick={clickAddButton} variant="contained" className="button" color="primary">
              Add
            </Button>
            <Button
              style={{ marginLeft: '16px' }}
              className="button"
              onClick={onClose}
              color="primary"
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

AddProjectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddProjectDialog;
